import { render } from "./Underground.vue?vue&type=template&id=c066ec40&scoped=true"
import script from "./Underground.vue?vue&type=script&lang=js"
export * from "./Underground.vue?vue&type=script&lang=js"

import "./Underground.vue?vue&type=style&index=0&id=c066ec40&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c066ec40"]])

export default __exports__